import React from 'react';
import { colors, radii, shadows } from '../theme/tokens';

type Variant = 'primary' | 'gold' | 'outline' | 'outlineNeutral';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: React.ReactNode;
}

/* §4 Buttons — primary green / gold / outline. */
export const Button: React.FC<ButtonProps> = ({ variant = 'primary', children, style, ...rest }) => {
  const [hover, setHover] = React.useState(false);
  const base: React.CSSProperties = { cursor: 'pointer', fontWeight: 600, border: 'none' };
  let vs: React.CSSProperties = {};
  if (variant === 'primary') {
    vs = {
      background: colors.brandGreen,
      color: colors.cream,
      borderRadius: radii.smallCard,
      padding: '12px 20px',
      fontSize: 13.5,
      boxShadow: shadows.primaryBtn,
      filter: hover ? 'brightness(1.12)' : undefined,
    };
  } else if (variant === 'gold') {
    vs = {
      background: colors.gold,
      color: '#fff',
      borderRadius: radii.smallCard,
      padding: '12px 20px',
      fontSize: 13.5,
      boxShadow: shadows.goldBtn,
      filter: hover ? 'brightness(1.1)' : undefined,
    };
  } else if (variant === 'outline') {
    vs = {
      background: hover ? colors.brandGreen : '#fff',
      color: hover ? '#fff' : colors.brandGreen,
      border: `1px solid ${colors.brandGreen}`,
      borderRadius: radii.input,
      padding: '7px 15px',
      fontSize: 12,
    };
  } else {
    vs = {
      background: '#fff',
      color: colors.muted,
      border: `1px solid ${colors.borderWarm}`,
      borderRadius: radii.input,
      padding: '7px 15px',
      fontSize: 12,
    };
  }
  return (
    <button
      {...rest}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ ...base, ...vs, ...style }}
    >
      {children}
    </button>
  );
};

export default Button;
